import script from "./psiShopSPaymentStastics.vue?vue&type=script&setup=true&lang=js"
export * from "./psiShopSPaymentStastics.vue?vue&type=script&setup=true&lang=js"

import "./psiShopSPaymentStastics.vue?vue&type=style&index=0&id=2fc250e6&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc250e6"]])

export default __exports__